import Image from 'next/image'

import { FloorType } from '../types'

type TopSectionBlockProps = {
  topSectionData: FloorType['top_section']
}

const TopSectionBlock = ({ topSectionData }: TopSectionBlockProps) => {
  if (!topSectionData) return

  return (
    <div className="w-full bg-white px-0 pb-[40px] pt-0">
      <div className="flex flex-col items-start justify-between gap-6 xl:flex-row xl:items-center xl:gap-8">
        <div className="relative w-full pb-[11px] pt-[5px]">
          <Image
            src={topSectionData?.image}
            alt="top-section"
            className="h-[48px] w-[383px] object-contain"
            width={0}
            height={0}
            unoptimized
            sizes="100vw"
          />
        </div>

        <div className="flex w-full justify-end">
          {topSectionData?.items.map((item, index) => (
            <div
              key={`${index}-${item.title}-${item.subtitle}`}
              className="flex min-w-[296px] flex-col items-end gap-[8px]">
              <span className="font-miSansSemiBold520 text-[28px]">{item.title}</span>
              <span className="max-w-[250px] font-miSansMedium380 text-base text-[#6E6E73]">
                {item.subtitle}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TopSectionBlock
